export default __webpack_public_path__ + "static/media/JSS.83140d8b.png";